import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { GoodbyePageComponent } from './goodbye-page/goodbye-page.component';
import { HeaderModule } from '@shared/header/header.module';
import { FooterModule } from '@shared/footer/footer.module';
import { DataLoaderModule } from '@shared/data-loader/data-loader.module';

@NgModule({
	declarations: [GoodbyePageComponent],
	imports: [
		CommonModule,
		TranslateModule,
		HeaderModule,
		FooterModule,
		DataLoaderModule
	]
})
export class GoodbyePageModule {}
